import { useState, useCallback } from 'react';

export function useComparisonState() {
  const [compareMode, setCompareMode] = useState(false);
  const [comparisonData, setComparisonData] = useState(null);
  const [comparisonMode, setComparisonMode] = useState('current');
  const [selectedForCompare, setSelectedForCompare] = useState([]);
  const [availablePeriods, setAvailablePeriods] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState(null);
  const [loadingPeriods, setLoadingPeriods] = useState(false);
  const [historyAvailability, setHistoryAvailability] = useState([]);
  const [syncingHistory, setSyncingHistory] = useState(null);
  const [batchSyncing, setBatchSyncing] = useState(false);
  const [syncProgress, setSyncProgress] = useState(null);

  const resetComparison = useCallback(() => {
    setCompareMode(false);
    setComparisonData(null);
    setSelectedForCompare([]);
    setComparisonMode('current');
    setAvailablePeriods([]);
    setSelectedPeriod(null);
    setHistoryAvailability([]);
    setSyncingHistory(null);
    setBatchSyncing(false);
    setSyncProgress(null);
  }, []);

  const toggleDomainForCompare = useCallback((domain) => {
    setSelectedForCompare(prev => {
      const normalized = domain.toLowerCase().replace(/^https?:\/\//, '').replace(/\/$/, '');
      const exists = prev.some(d => 
        d.toLowerCase().replace(/^https?:\/\//, '').replace(/\/$/, '') === normalized
      );
      if (exists) {
        return prev.filter(d => 
          d.toLowerCase().replace(/^https?:\/\//, '').replace(/\/$/, '') !== normalized
        );
      } else {
        return [...prev, domain];
      }
    });
  }, []);

  const addDomainToCompare = useCallback((domain) => {
    if (!domain || typeof domain !== 'string') return false;
    const normalized = domain.toLowerCase().replace(/^https?:\/\//, '').replace(/\/$/, '');
    if (!normalized) return false;
    
    const exists = selectedForCompare.some(d => 
      d.toLowerCase().replace(/^https?:\/\//, '').replace(/\/$/, '') === normalized
    );
    
    if (!exists && selectedForCompare.length < 10) {
      setSelectedForCompare(prev => [...prev, `https://${normalized}`]);
      return true;
    }
    return false;
  }, [selectedForCompare]);

  const removeDomainFromCompare = useCallback((domain) => {
    const normalized = domain.toLowerCase().replace(/^https?:\/\//, '').replace(/\/$/, '');
    setSelectedForCompare(prev => 
      prev.filter(d => d.toLowerCase().replace(/^https?:\/\//, '').replace(/\/$/, '') !== normalized)
    );
  }, []);

  const isDomainSelected = useCallback((domain) => {
    const normalized = domain.toLowerCase().replace(/^https?:\/\//, '').replace(/\/$/, '');
    return selectedForCompare.some(d => 
      d.toLowerCase().replace(/^https?:\/\//, '').replace(/\/$/, '') === normalized
    );
  }, [selectedForCompare]);

  return {
    compareMode,
    setCompareMode,
    comparisonData,
    setComparisonData,
    comparisonMode,
    setComparisonMode,
    selectedForCompare,
    setSelectedForCompare,
    availablePeriods,
    setAvailablePeriods,
    selectedPeriod,
    setSelectedPeriod,
    loadingPeriods,
    setLoadingPeriods,
    historyAvailability,
    setHistoryAvailability,
    syncingHistory,
    setSyncingHistory,
    batchSyncing,
    setBatchSyncing,
    syncProgress,
    setSyncProgress,
    resetComparison,
    toggleDomainForCompare,
    addDomainToCompare,
    removeDomainFromCompare,
    isDomainSelected
  };
}

export default useComparisonState;
